import { useMemo } from 'react'
import { createTheme } from '@material-ui/core/styles'
import { useAppDispatch } from 'app/hooks'
import { useDisplayTheme } from 'hooks/useUiState'
import { setDisplayTheme } from 'features/ui/uiSlice'
import { Theme } from 'features/ui/types'

const useRetrieveTheme = () => {
  const dispatch = useAppDispatch()
  const displayTheme = useDisplayTheme()

  const setTheme = (theme: Theme) => {
    dispatch(setDisplayTheme(theme))
  }

  // TODO: muiTheme is for WaveLoading component which uses mui skeleton. Should be replaced by @netbaseuid/skeleton.
  const muiTheme = useMemo(
    () =>
      createTheme({
        palette: {
          type: displayTheme
        }
      }),
    [displayTheme]
  )

  return { displayTheme, muiTheme, setTheme }
}

export default useRetrieveTheme
